import React, { useEffect, useState } from "react";
import { RiDeleteBin5Line } from "react-icons/ri";
import { MwButton, MwInputFile } from "../../../components/ui";
import { useTranslation } from "react-i18next";

const ProductImages = ({
  productHomePic,
  setProductImagesDefault,
  productHomePicDefault,
  loadingUploadHomePic,
  handleHomePicUpload,
  productImages,
  setProductImages,
  loadingUploadProductImages,
  handleImagesItemUpload,
  loadingDeleting,
  handleDelete,
}) => {
  const [_picProduct, _setPicProduct] = useState(
    productHomePic || productHomePicDefault
  );

  const [t, i18n] = useTranslation("global");

  const getImageKey = (url) => {
    if (!url) return "";
    const parts = url.split("/");
    return `${parts[3]}/${parts[4]}`;
  };

  const _deleteHandler = (key, image) => {
    handleDelete(key);

    if (image === "homePic") {
      _setPicProduct("");
      setProductImagesDefault("");
    } else {
      setProductImages(productImages.filter((img) => img !== image));
    }
  };

  useEffect(() => {
    if (productHomePic) {
      _setPicProduct(productHomePic);
    }

    if (productHomePicDefault) {
      _setPicProduct(productHomePicDefault);
    }
  }, [productHomePicDefault, productHomePic]);

  useEffect(() => {
    if (productHomePic) {
      setProductImagesDefault &&
        setProductImagesDefault(productHomePic);
    }
  }, [productHomePic]);

  return (
    <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-200 space-y-8">

      {/* Main Image */}
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-start">

        {/* Upload */}
        <div className="lg:col-span-8">
          <div className="bg-slate-50 border border-dashed border-slate-300 rounded-2xl p-5">
            <MwInputFile
              label={t("product.main_image_label")}
              loading={loadingUploadHomePic}
              onChangeHandler={handleHomePicUpload}
            />
          </div>
        </div>

        {/* Preview */}
        <div className="lg:col-span-4">
          {_picProduct ? (
            <div className="relative group bg-slate-50 rounded-2xl border p-4 flex items-center justify-center min-h-[220px] overflow-hidden">

              <img
                src={_picProduct}
                title="Product"
                alt="Product"
                className="max-h-[180px] object-contain transition-all duration-300 group-hover:scale-105"
              />

              <button
                type="button"
                onClick={() =>
                  _deleteHandler(getImageKey(_picProduct), "homePic")
                }
                className="absolute top-3 right-3 bg-red-500 hover:bg-red-600 text-white rounded-full p-2 transition-all"
              >
                <RiDeleteBin5Line size={18} />
              </button>
            </div>
          ) : (
            <div className="bg-slate-50 border border-dashed border-slate-300 rounded-2xl min-h-[220px] flex items-center justify-center text-slate-400 text-sm">
              {t("product.no_image")}
            </div>
          )}
        </div>
      </div>

      {/* Divider */}
      <div className="border-t pt-6">

        {/* Multi Upload */}
        <div className="bg-slate-50 border border-dashed border-slate-300 rounded-2xl p-5">
          <MwInputFile
            isMultiple={true}
            label={t("product.product_images_label")}
            loading={loadingUploadProductImages}
            onChangeHandler={handleImagesItemUpload}
          />
        </div>

        {/* Images Grid */}
        {productImages?.length > 0 && (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5 mt-6">

            {productImages.map((item, index) => (
              <div
                key={index}
                className="relative group bg-slate-50 border rounded-2xl overflow-hidden p-3 flex items-center justify-center min-h-[180px]"
              >

                <img
                  src={item}
                  title="Product"
                  alt="Product"
                  className="max-h-[140px] object-contain transition-all duration-300 group-hover:scale-105"
                />

                <button
                  type="button"
                  disabled={loadingDeleting}
                  onClick={() =>
                    _deleteHandler(getImageKey(item), item)
                  }
                  className="absolute top-2 right-2 bg-red-500 hover:bg-red-600 text-white rounded-full p-2 opacity-0 group-hover:opacity-100 transition-all duration-300"
                >
                  <RiDeleteBin5Line size={16} />
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductImages;